import Stack from "@mui/material/Stack";
import DataContainer from "../../../Utilities/DataContainer";
import RenderTextField from "../../../Utilities/Forms/RenderTextField";
import Grid from '@mui/material/Grid2';
import RenderPercentageValueBetweenTwoValues from "../../../Utilities/Forms/RenderPercentageValueBetweenTwoValues";

interface IProps {
    isReadOnly: boolean;
    landuse: string;
    subuse: string;
}

export default function Employees({ isReadOnly, landuse, subuse }: IProps) {
    return (
        <DataContainer title={"Employees"}>
            <Stack spacing={1}>
                {
                    (() => {
                        const validCodes = new Set([
                            "01/A", "01/B", "01/C", "01/D", "01/E", "01/F", "01/G", "01/H", "01/I", "01/J", "01/K", "01/L", "01/M", "01/N", "01/O", "01/P", "01/Q", "01/R", "01/S",
                            "02/A", "02/B", "02/C", "02/D", "02/E", "02/F", "02/G", "02/H", "02/I",
                            "04/A", "04/B", "04/C", "04/D", "04/E", "04/F",
                            "05/A", "05/N", "05/B", "05/C", "05/D", "05/E", "05/F", "05/G", "05/H", "05/I", "05/J", "05/K", "05/L", "05/M",
                            "06/A", "06/B", "06/C", "06/D", "06/E", "06/F", "06/G", "06/H", "06/I", "06/J", "06/K", "06/L",
                            "07/A", "07/B", "07/C", "07/E", "07/F", "07/G", "07/H", "07/I", "07/J", "07/K", "07/L", "07/M", "07/O", "07/P", "07/Q", "07/R", "07/S", "07/T", "07/U", "07/V", "07/W", "07/X",
                            "08/A",
                            "09/A", "09/B", "09/C", "09/D", "09/E", "09/F", "09/G", "09/H",
                            "10/A",
                            "11/A",
                            "12/A", "12/C",
                            "13/A", "13/B", "13/C",
                            "14/A",
                            "15/A", "15/B", "15/C", "15/D",
                            "16/A", "16/B", "16/C"
                        ]);

                        return validCodes.has(`${landuse}/${subuse}`);
                    })() && (
                        <>
                            <Grid container justifyContent='center' alignItems='center'>
                                <Grid size={11}>
                                    <RenderTextField
                                        label="Total Employees"
                                        name="employees.totalEmployees"
                                        readOnly={isReadOnly}
                                    />
                                </Grid>
                                <Grid size={1} />
                                <Grid size={11}>
                                    <RenderTextField
                                        label="Full Time Employees"
                                        name="employees.totalFullTimeEmployees"
                                        readOnly={isReadOnly}
                                    />
                                </Grid>
                                <Grid size={1}>
                                    <RenderPercentageValueBetweenTwoValues
                                        totalValuePropertyName={"employees.totalEmployees"}
                                        currentValuePropertyName={"employees.totalFullTimeEmployees"} />
                                </Grid>
                                <Grid size={11}>
                                    <RenderTextField
                                        label="Part Time Employees"
                                        name="employees.totalPartTimeEmployees"
                                        readOnly={isReadOnly}
                                    />
                                </Grid>
                                <Grid size={1}>
                                    <RenderPercentageValueBetweenTwoValues
                                        totalValuePropertyName={"employees.totalEmployees"}
                                        currentValuePropertyName={"employees.totalPartTimeEmployees"} />
                                </Grid>
                            </Grid>
                            <RenderTextField
                                label="Approximate % of total employees Working 9-5 or similar"
                                name="employees.approxPercentEmployeesWorking9Till5"
                                readOnly={isReadOnly}
                                endAdornment="%"
                            />
                            <RenderTextField
                                label="Approximate % of total employees working from home (any amount)"
                                name="employees.approxTotalEmployeesWfh"
                                readOnly={isReadOnly}
                                endAdornment="%"
                            />
                        </>
                    )
                }
                {
                    (landuse === "03" && subuse === "P") && (
                        <RenderTextField
                            label="Number Of On Site Staff"
                            name="employees.numberOfOnSiteStaff"
                            readOnly={isReadOnly}
                        />
                    )
                }
            </Stack>
        </DataContainer>
    );
}
